import { fromJS } from "immutable"

const initReportDetailData = fromJS({});

const initFilterDataReportDetail = fromJS({
  startDate: "",
  endDate: "",
  ireturnNum: "",
  invoiceNo: "",
  customerName: "",
  plantName: "",
  reason: "",
  status: "",
  pageNo: 1,
  pageSize: 10,
});

export function filterDataReportDetail(
  state = initFilterDataReportDetail,
  action
) {
  switch (action.type) {
    case "FILTER_SET_START_DATE_SUCCESS":
      return state.set("startDate", action.startDate);
    case "FILTER_SET_END_DATE_SUCCESS":
      return state.set("endDate", action.endDate);
    case "FILTER_SET_RET_NUMBER_SUCCESS":
      return state.set("retNumber", action.retNumber);
    case "FILTER_SET_INVOICE_NO_SUCCESS":
      return state.set("invoiceNo", action.invoiceNo);
    case "FILTER_SET_CUSTOMER_NAME_SUCCESS":
      return state.set("customerName", action.customerName);
    case "FILTER_SET_CUSTOMER_CODE_SUCCESS":
      return state.set("customerCode", action.customerCode);
    case "FILTER_SET_PLANT_NAME_SUCCESS":
      return state.set("plantName", action.plantName);
    case "FILTER_SET_REASON_CODE_SUCCESS":
      return state.set("reasonCode", action.reasonCode);
    case "FILTER_SET_STATUS_SUCCESS":
      return state.set("status", action.status);
    case "FILTER_SET_PAGE_NO_SUCCESS":
      return state.set("pageNo", action.pageNo);
    case "FILTER_SET_PAGE_SIZE_SUCCESS":
      return state.set("pageSize", action.pageSize);
    default:
      return state;
  }
}

export function reportDetailData(
  state = initReportDetailData, action
  ) {
  switch (action.type) {
    case "REPORT_DETAIL_FETCH_DATA_SUCCESS":
      return fromJS(action.dataReportDetail);
    default:
      return state;
  }
}

export function valueReportDetailData(state = fromJS([]), action) {
  switch (action.type) {
    case "VALUE_REPORT_DETAIL_DATA_SUCCESS":
      return fromJS(action.detail);
    default:
      return state;
  }
}
